import SnackbarAlert from '../components/shared/SnackbarAlert';


const getErrorMessage = (error = {}, alertFunction, defaultMessage = '') => {

    const errorMessage = error.response?.data?.message || defaultMessage || 'Ocorreu um erro ao executar a ação!'

    if (!alertFunction) {
        SnackbarAlert.error(errorMessage);
        return;
    }

    alertFunction(errorMessage, 'error');
}

export default {
    getErrorMessage
};
